const API = '/api';

let accessToken: string | null = null;
let refreshing: Promise<void> | null = null;

export function setAccessToken(t: string | null): void {
  accessToken = t;
}

export function getAccessToken(): string | null {
  return accessToken;
}

async function refresh(): Promise<void> {
  const res = await fetch(`${API}/auth/refresh`, {
    method: 'POST',
    credentials: 'include',
  });
  if (!res.ok) {
    accessToken = null;
    throw new Error('refresh_failed');
  }
  const data = (await res.json()) as { accessToken: string };
  accessToken = data.accessToken;
}

// Форсирует получение токена: если в памяти нет — пытается refresh через cookie.
// Используется, например, перед WS-подключением, где нужен готовый Bearer в URL.
export async function ensureFreshAccessToken(): Promise<string> {
  if (!accessToken) {
    refreshing ??= refresh().finally(() => {
      refreshing = null;
    });
    await refreshing;
  }
  if (!accessToken) throw new Error('no_access_token_after_refresh');
  return accessToken;
}

export async function apiFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const headers = new Headers(init.headers);
  if (accessToken) headers.set('Authorization', `Bearer ${accessToken}`);
  let res = await fetch(`${API}${path}`, { ...init, headers, credentials: 'include' });

  if (res.status === 401 && accessToken) {
    try {
      refreshing ??= refresh().finally(() => {
        refreshing = null;
      });
      await refreshing;
      headers.set('Authorization', `Bearer ${accessToken}`);
      res = await fetch(`${API}${path}`, { ...init, headers, credentials: 'include' });
    } catch {
      // остаёмся с 401
    }
  }
  return res;
}

import type { UserRole } from '@mm/shared';

export type User = {
  id: string;
  email: string;
  phone: string | null;
  name: string;
  role: UserRole;
};

export async function tryAutoLogin(): Promise<{ user: User } | null> {
  try {
    await refresh();
    const r = await apiFetch('/auth/me');
    if (!r.ok) return null;
    return (await r.json()) as { user: User };
  } catch {
    return null;
  }
}

export async function logout(): Promise<void> {
  await fetch(`${API}/auth/logout`, { method: 'POST', credentials: 'include' });
  setAccessToken(null);
}
